/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import { useRequestData, useLabels } from 'wsm-common-data';
import { FetchReviewsContext } from '../providers/FetchReviewsProvider';
import { updateRatingFilters } from '../actions/reviewsFilters';
import { round } from '../utils';

const RatingFilters = () => {
	// hooks
	const { deviceType } = useRequestData();
	const labels = useLabels();
	/**
	 * @type {FetchReviewsContextValue}
	 */
	const { isLoading, fetchReviews } = useContext(FetchReviewsContext);
	/**
	 * @type {RatingFiltersReduxState}
	 */
	const {
		ratings: rawRatings,
		currentTotalRatings,
		currentAvgRating
	} = useSelector((state) => ({
		ratings: state.reviewsFilters.ratings,
		currentTotalRatings: state.reviewsInfo.currentTotalRatings,
		currentAvgRating: state.reviewsInfo.currentAvgRating
	}));
	const dispatch = useDispatch();
	// variables
	const isDesktop = deviceType === 'DESKTOP';
	// sort ratings from highest to lowest
	const ratings = Object.entries(rawRatings).sort(
		([ratingA], [ratingB]) => ratingB - ratingA
	);
	// handlers
	const handleRatingFilterChange = (event) => {
		const { value, checked } = event.target;
		const rating = parseInt(value, 10);
		dispatch(updateRatingFilters(rating, checked));
		const queries = {
			ratings: {
				[rating]: checked
			}
		};
		fetchReviews(1, queries);
	};
	// classes
	const fieldsetClasses = ['rating-filters', 'filters'];
	const legendClasses = ['rating-filters__legend', 'font-weight-bold'];
	const ratingFilter = ['rating-filters__filter', 'filter'];
	const ratingStarSize = isDesktop ? '1.5rem' : '2.5rem';
	const ratingStarLabelCommonStyles = {
		'--rating-stars-width': `calc(${ratingStarSize} * 5)`,
		'--rating-star-height': ratingStarSize,
		'--rating-star-font-size': ratingStarSize
	};
	const ratingStars = ['rating-stars', 'mb-0'];
	return (
		<fieldset className={setClassNames(fieldsetClasses)}>
			<legend className={setClassNames(legendClasses)}>
				{labels.get('VW_REVIEWS_FILTER_RATING')}
			</legend>
			<p className="text-center mb-0">
				{currentTotalRatings}{' '}
				<span className="font-weight-bold">
					{labels.get('VW_REVIEWS_RATINGS')}
				</span>
			</p>
			<p className="text-center mb-0">
				{round(currentAvgRating, 1)}{' '}
				<span className="font-weight-bold">
					{labels.get('VW_REVIEWS_AVERAGE')}
				</span>{' '}
			</p>
			{ratings.map(([rating, value]) => {
				const id = `rating-filters__checkbox--${rating}`;
				const name =
					rating === '1' ? `${rating} star` : `${rating} stars`;
				return (
					<label
						htmlFor={id}
						className={setClassNames(ratingFilter)}
						style={{
							...ratingStarLabelCommonStyles,
							'--rating-star-value': rating
						}}
						aria-label={name}
						key={id}
					>
						<input
							id={id}
							type="checkbox"
							checked={value}
							value={rating}
							disabled={isLoading}
							onChange={handleRatingFilterChange}
						/>
						<span
							aria-hidden
							className={setClassNames(ratingStars)}
						/>
					</label>
				);
			})}
		</fieldset>
	);
};

export default RatingFilters;
